<h1 class="title">Användare</h1>
<div class="scroll-container">
  <app-table [config]="tableConfig"></app-table>
</div>
